import { render, staticRenderFns } from "./CustomSelectGroup.vue?vue&type=template&id=6847b407&"
import script from "./CustomSelectGroup.vue?vue&type=script&lang=js&"
export * from "./CustomSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports